import {
  CalendarSeatSetupOrder,
  getSetupOrderForRbacFlow,
  MeetingsSetupOrder,
  PlaybooksRoleSetupOrder,
  RBAC_FLOWS,
  ReportingRoleSetupOrder,
  TouchlessSetupOrder,
} from 'constants/flowConstants'
import { getFlow } from 'modules/user/selectors'
import { resolveCompletionUrl } from 'utils/routing'

const getRoot = (state) => state.router
export const getPathname = (state) => getRoot(state).location.pathname
export const getSearch = (state) => getRoot(state).location.search

const getOrder = (pathname, state) => {
  const flow = getFlow(state)

  if (RBAC_FLOWS.indexOf(flow) > -1) {
    return getSetupOrderForRbacFlow(flow)
  }
  if (pathname.startsWith('/setup/calendaring')) {
    return CalendarSeatSetupOrder
  }
  if (
    pathname.startsWith('/setup/enterprise') &&
    pathname.includes('playbooks')
  ) {
    return PlaybooksRoleSetupOrder
  }
  if (
    pathname.startsWith('/setup/enterprise') &&
    pathname.includes('reporting')
  ) {
    return ReportingRoleSetupOrder
  }
  if (pathname.includes('touchless') || pathname.includes('start')) {
    return TouchlessSetupOrder
  }
  return MeetingsSetupOrder
}

export const getPercentage = (state) => {
  const pathname = getPathname(state)
  const order = getOrder(pathname, state)
  const section = pathname.split('/').slice(1).join('/')

  // only want to show a complete progress bar to the calendaring flow and enterprise role flows
  if (
    pathname.startsWith('/setup/calendaring') ||
    pathname.startsWith('/setup/enterprise') ||
    pathname.startsWith('/invite')
  ) {
    return Math.round((order.indexOf(section) / (order.length - 1)) * 100)
  } else {
    return Math.round((order.indexOf(section) / order.length) * 100)
  }
}

export const getIsFlowComplete = (state) => {
  const pathname = getPathname(state)
  const order = getOrder(pathname, state)
  const section = pathname.split('/').slice(1).join('/')

  return order.indexOf(section) === order.length - 1
}

export const getNextPath = (state) => {
  const pathname = getPathname(state)
  const order = getOrder(pathname, state)
  const section = pathname.split('/').slice(1).join('/')
  const curStepIndex = order.indexOf(section)

  return `/${order[curStepIndex + 1]}`
}

export const getCompletionUrl = (state) => {
  const flow = getFlow(state)
  return resolveCompletionUrl(flow)
}
